import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { pluralizeWithCount } from "@common/helpers/string";

interface Props {
    filters: Pick<FiltersTypes, "transactionIds">;
}

export const TransactionIdsFilterLabel: React.FC<Props> = ({ filters }) => {
    const transactionIds = filters.transactionIds;

    if (!transactionIds || transactionIds.length === 0) {
        return null;
    }

    return <>{pluralizeWithCount("transaction", transactionIds.length)}</>;
};
